<ion-header>
    <ion-toolbar>


        <ion-buttons slot="start">
            <ion-button (tap)="closeModal()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>

        <ion-title>Scan Item</ion-title>

    </ion-toolbar>
</ion-header>

<ion-content *ngIf="screenPreferences">
    <!--ion-card>

      <ion-list>
        <ion-item>
          <ion-label position="floating">Scan Formats</ion-label>
          <ion-select multiple [compareWith]="barcodeFormatCompare" [(ngModel)]="configuration.selectedScannerFormats">
            <ion-select-option class="ion-text-wrap" *ngFor="let allFormat of allowedFormats" [value]="allFormat">
              {{ allFormat.shortDescription }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-card-->

    <ion-grid>
        <ion-row>
            <ion-col size="5">
                <ion-select [(ngModel)]="screenPreferences.selectedBarcodeDevice"
                            (ngModelChange)="saveConfig();" interface="popover"
                            [compareWith]="mediaDeviceCompare">

                    <ion-select-option *ngFor="let device of barcodeMediaDevices"
                                       [value]="device">{{device.label}}</ion-select-option>
                </ion-select>
            </ion-col>
            <ion-col size="1">
                <ion-button size="small" (click)="openBarcodeFormat()">
                    <ion-icon name="barcode"></ion-icon>
                </ion-button>
            </ion-col>
            <ion-col size="3">
                <ion-select #barcodeFormatSelect hidden multiple [compareWith]="barcodeFormatCompare"
                            [(ngModel)]="screenPreferences.selectedScannerFormats" (ionChange)="saveConfig()">
                    <ion-select-option class="ion-text-wrap" *ngFor="let allFormat of allowedFormats"
                                       [value]="allFormat">
                        {{ allFormat.shortDescription }}
                    </ion-select-option>
                </ion-select>
            </ion-col>
            <ion-col size="3">
                <ion-button size="small" #torchbutton (tap)="handleClickingTorch(); ">
                    <ion-icon size="small" slot="icon-only" name="flashlight" style="display: inline-block"></ion-icon>
                </ion-button>
            </ion-col>
        </ion-row>
    </ion-grid>

    <zxing-scanner #scanner
                   (camerasFound)="onCamerasFound($event)"
                   [torch]="torchEnabled"
                   (torchCompatible)="onTorchCompatible($event)"
                   [formats]="allowedFormats"
                   [device]="selectedDevice"
                   [enable]="enabled"
                   [tryHarder]="true"
                   (scanSuccess)="handleScanResult($event)"
                   (permissionResponse)="onHasPermission($event)">
    </zxing-scanner>
    <ion-item>
        <ion-input [(ngModel)]="manualInput" placeholder="Input the barcode here"></ion-input>
        <ion-button color="light" (click)="handleScanResult(manualInput)">
            <ion-icon name="add" slot="icon-only"></ion-icon>
        </ion-button>
    </ion-item>
</ion-content>
